import type { InativarAtivarReferenciaProps } from "./types-inativar-ativar-referencia";
import { useInativarAtivarReferencia } from "./use-inativar-ativar-referencia";
import { InativarAtivarReferenciaView } from "./view-inativar-ativar-referencia";

export function InativarAtivarReferencia(props: InativarAtivarReferenciaProps) {
  const vm = useInativarAtivarReferencia(props);

  return <InativarAtivarReferenciaView {...vm} />;
}

export type * from "./types-inativar-ativar-referencia";
